// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema, urlSchema } from '../../utils/codecUtils.schema';

export const workspaceSchema = z.object({
  id: idSchema,
  name: z.string(),
  url: urlSchema,
  autopilot: z.boolean(),
  organization: urlSchema,
  queues: z.array(urlSchema),
  metadata: z.unknown().optional(),
});
